import { TextIcon } from '@europrocurement/flexy-components';
import { tarifFrance } from '@europrocurement/l2d-utils';
import { Button, Divider, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { faCcMastercard, faCcVisa } from '@fortawesome/free-brands-svg-icons';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TblUtilisateurJsonldPanierunitaireRead } from '@europrocurement/l2d-domain/openApi/ApiFacturation';
import { faCreditCard } from '@fortawesome/sharp-regular-svg-icons';
import PeoplePreview from '../../../../Dossiers/components/liste/PeoplePreview/PeoplePreview';

export type PanierPayProps = {
    ttcAPayer: number;
    recouvrement?: TblUtilisateurJsonldPanierunitaireRead;
    onClick: () => void;
    type?: 'recouvrement' | 'paiement';
};

const PanierPay: React.FunctionComponent<PanierPayProps> = function (props) {
    const { ttcAPayer, onClick, type = 'paiement', recouvrement } = props;
    if (ttcAPayer === 0) {
        return (
            <>
                <Typography variant="l2dh6">Paiement déjà effectué</Typography>

                <TextIcon
                    gap="8px"
                    icon={{ props: { icon: ['fasl', 'credit-card'] } }}
                    typoProps={{ variant: 'l2dlabel', color: 'text.gris70' }}
                >
                    Plus rien à payer
                </TextIcon>
            </>
        );
    }

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '15px',
            }}
        >
            <Typography variant="l2dh6">Procéder au paiement</Typography>

            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    gap: '15px',
                    alignItems: 'center',
                }}
            >
                <TextIcon
                    gap="8px"
                    icon={{ props: { icon: ['fasl', 'lock'] } }}
                    typoProps={{ variant: 'l2dlabel', color: 'text.gris70' }}
                >
                    Paiement sécurisé
                </TextIcon>

                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        gap: '15px',
                    }}
                >
                    <FontAwesomeIcon icon={faCcVisa} />
                    <FontAwesomeIcon icon={faCcMastercard} />
                    <FontAwesomeIcon icon={faCreditCard} />
                </Box>
            </Box>

            <Divider />
            {ttcAPayer > 0 ? (
                <Button
                    variant="contained"
                    onClick={() => {
                        onClick();
                    }}
                >
                    <b>{`Payer ${tarifFrance(Math.round(ttcAPayer * 100) / 100)}`}</b>
                </Button>
            ) : (
                <Button
                    variant="contained"
                    disabled
                >
                    <b>Payer</b>
                </Button>
            )}
            {type === 'recouvrement' && recouvrement && recouvrement.prenom && recouvrement.nom ? (
                <>
                    <Divider />
                    <Typography component="span">Votre chargé(e) de recouvrement :</Typography>
                    <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <PeoplePreview
                            firstName={recouvrement?.prenom}
                            lastName={recouvrement?.nom}
                            userIdentifier={recouvrement.userIdentifier ?? undefined}
                            sx={{ margin: '0 10px 0 0' }}
                            auth={false}
                        />
                        <Typography component="span">
                            {`${recouvrement?.prenom} ${recouvrement?.nom}`}
                            {recouvrement.ligneDirecte ? ` - ${recouvrement?.ligneDirecte}` : null}
                        </Typography>
                    </Box>
                </>
            ) : null}
        </Box>
    );
};

export default PanierPay;
